/**
 * New Combo PDP — isolated dynamic variant filtering (vanilla JS).
 * Depends on theme globals: formatMoney (theme-global.js), MinimogEvents / MinimogTheme (optional).
 */
(function () {
  'use strict';

  /** Trim + stringify so Liquid JSON, dataset attrs, and variant.optionN always compare reliably. */
  function norm(s) {
    return String(s == null ? '' : s).trim();
  }

  function optionValueAt(variant, position) {
    if (!variant) return '';
    if (position === 0) return norm(variant.option1);
    if (position === 1) return norm(variant.option2);
    if (position === 2) return norm(variant.option3);
    return '';
  }

  function getValidValues(variants, selections, position) {
    var set = {};
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < position; j++) {
        if (optionValueAt(v, j) !== norm(selections[j])) {
          ok = false;
          break;
        }
      }
      if (!ok) continue;
      var val = optionValueAt(v, position);
      if (val !== '') set[val] = true;
    }
    return Object.keys(set);
  }

  /** True when Size row should be hidden: no choices or every valid choice is only "0". */
  function shouldHideSizeOnlyZero(validVals) {
    if (!validVals || validVals.length === 0) return true;
    for (var i = 0; i < validVals.length; i++) {
      if (norm(validVals[i]) !== '0') return false;
    }
    return true;
  }

  function findMatchingVariants(variants, selections, position, value) {
    var want = norm(value);
    var list = [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < position; j++) {
        if (optionValueAt(v, j) !== norm(selections[j])) {
          ok = false;
          break;
        }
      }
      if (!ok) continue;
      if (optionValueAt(v, position) !== want) continue;
      list.push(v);
    }
    return list;
  }

  function normalizeSelections(variants, selections, changedIndex, optionOrder) {
    var count = optionOrder.length;
    var out = selections.slice();
    for (var p = changedIndex + 1; p < count; p++) {
      var valid = getValidValues(variants, out, p);
      var cur = norm(out[p]);
      if (valid.indexOf(cur) === -1) {
        var order = optionOrder[p];
        var picked = null;
        for (var i = 0; i < order.length; i++) {
          var cand = norm(order[i]);
          if (valid.indexOf(cand) !== -1) {
            picked = cand;
            break;
          }
        }
        if (picked != null) {
          out[p] = picked;
        } else if (valid.length > 0) {
          out[p] = valid[0];
        }
      }
    }
    return out;
  }

  function resolveVariant(variants, selections) {
    var n = selections.length;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < n; j++) {
        if (optionValueAt(v, j) !== norm(selections[j])) {
          ok = false;
          break;
        }
      }
      if (ok) return v;
    }
    return null;
  }

  function parseJSON(el) {
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function emitVariantChange(sectionId, variant) {
    if (typeof window.MinimogEvents !== 'undefined' && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.variantChange, {
        data: { variant: variant, sectionId: sectionId, html: null },
      });
    }
    document.dispatchEvent(
      new CustomEvent('variant:changed', {
        detail: { variant: variant },
      })
    );
  }

  function updateGhostPickerScript(root, variant) {
    var ghost = root.querySelector('variant-picker [data-selected-variant]');
    if (ghost) ghost.textContent = JSON.stringify(variant);
  }

  function updateVariantInputs(sectionId, variantId) {
    var q =
      '#product-form-' +
      sectionId +
      ' input[name="id"], #product-form-installment-' +
      sectionId +
      ' input[name="id"]';
    document.querySelectorAll(q).forEach(function (inp) {
      inp.value = variantId != null ? String(variantId) : '';
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function replaceHistory(productUrl, variantId, enableHistory) {
    if (!enableHistory || !productUrl) return;
    var url = productUrl.split('?')[0];
    var tail = variantId ? '?variant=' + variantId : '';
    try {
      window.history.replaceState({}, '', url + tail);
    } catch (e) {}
  }

  function formatPriceMoney(cents) {
    var fmt = window.MinimogSettings && window.MinimogSettings.money_format;
    if (typeof window.formatMoney === 'function' && fmt) {
      return window.formatMoney(cents, fmt);
    }
    return (cents / 100).toFixed(2);
  }

  function fallbackComboPriceHtml(variant) {
    if (!variant) return '';
    var priceFmt = formatPriceMoney(variant.price);
    var sale =
      variant.compare_at_price &&
      variant.compare_at_price > variant.price;
    var cls = 'm-price' + (sale ? ' m-price--on-sale' : '');
    var html =
      '<div class="' +
      cls +
      '" data-sale-badge-type="percentage">' +
      '<div class="m-price__regular">' +
      '<span class="m-price-item m-price-item--regular m:text-xl md:m:text-2xl">' +
      priceFmt +
      '</span></div>' +
      '<div class="m-price__sale">' +
      '<span class="m-price-item m-price-item--sale m-price-item--last m:text-xl md:m:text-2xl">' +
      priceFmt +
      '</span>';
    if (sale) {
      var cmpFmt = formatPriceMoney(variant.compare_at_price);
      var pctOff = Math.floor(
        ((variant.compare_at_price - variant.price) * 100) /
          variant.compare_at_price
      );
      html +=
        '<s class="m-price-item m-price-item--regular">' +
        cmpFmt +
        '</s>' +
        '<span class="cstm_sale_percentage cstm_sale_percentage--inline">' +
        pctOff +
        '% Off</span>';
    }
    html +=
      '<span class="m-price__tax-note">MRP (Incl. of all taxes)</span>' +
      '</div>' +
      '<div class="m-price__unit-wrapper m:hidden"></div>' +
      '</div>';
    return html;
  }

  function updatePriceEl(sectionId, variant, priceMap) {
    var el = document.getElementById('Price-' + sectionId);
    if (!el) return;
    if (variant && priceMap && typeof priceMap === 'object') {
      var prebuilt =
        priceMap[String(variant.id)] ||
        priceMap[variant.id];
      if (prebuilt != null && prebuilt !== '') {
        el.innerHTML = prebuilt;
        return;
      }
    }
    if (!variant) return;
    el.innerHTML = fallbackComboPriceHtml(variant);
  }

  function updateSkuAvailability(sectionId, variant) {
    var skuEl = document.querySelector('#Sku-' + sectionId + ' [data-variant-sku]');
    if (skuEl) skuEl.textContent = variant && variant.sku ? variant.sku : 'N/A';

    var avWrap = document.querySelector('#Availability-' + sectionId + ' [data-availability]');
    if (!avWrap) return;
    var avail = variant && variant.available;
    avWrap.dataset.variant_available = avail ? 'true' : 'false';
    avWrap.classList.toggle('m-product-availability--outofstock', !avail);
    if (window.MinimogStrings) {
      avWrap.textContent = avail ? window.MinimogStrings.inStock || '' : window.MinimogStrings.outOfStock || '';
    }
  }

  function updatePickup(root, variant) {
    var pi = root.closest('product-info');
    var pu = pi && pi.querySelector('pickup-availability');
    if (pu && typeof pu.update === 'function') pu.update(variant);
  }

  function updateGallery(root, sectionId, variant) {
    var pi = root.closest('product-info');
    var gal = pi && pi.querySelector('[id^="MediaGallery-' + sectionId + '"]');
    if (gal && typeof gal.setActiveMedia === 'function') gal.setActiveMedia(variant);
  }

  function updateAtc(sectionId, variant) {
    var btn = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!btn) return;
    var txt = btn.querySelector('.m-add-to-cart--text');
    var ms = window.MinimogStrings || {};

    if (!variant) {
      btn.setAttribute('disabled', 'disabled');
      if (txt) txt.textContent = ms.unavailable || 'Unavailable';
      return;
    }
    if (!variant.available) {
      btn.setAttribute('disabled', 'disabled');
      if (txt) txt.textContent = ms.soldOut || 'Sold out';
      return;
    }
    btn.removeAttribute('disabled');
    if (txt) txt.textContent = ms.addToCart || 'Add to cart';
  }

  function updatePricePerItem(sectionId, variant) {
    var el = document.getElementById('PricePerItem-' + sectionId);
    if (!el || !variant) return;
    el.dataset.variantId = String(variant.id);
  }

  /** Shopify variant JSON shape differs by theme/version — normalize image URL. */
  function shopifyImgSrc(obj) {
    if (!obj) return '';
    if (typeof obj === 'string') return obj;
    if (typeof obj.src === 'string') return obj.src;
    if (typeof obj.url === 'string') return obj.url;
    return '';
  }

  function variantFeaturedSrc(v) {
    if (!v) return '';
    var u = shopifyImgSrc(v.featured_image);
    if (u) return u;
    var fm = v.featured_media;
    if (fm && typeof fm === 'object') {
      if (fm.media_type === 'image' || fm.media_type == null) {
        u = shopifyImgSrc(fm.preview_image);
        if (u) return u;
      }
      u = shopifyImgSrc(fm);
      if (u) return u;
    }
    u = shopifyImgSrc(v.image);
    if (u) return u;
    return '';
  }

  /** Liquid JSON keys may not match dataset after HTML decode — fuzzy lookup by normalized key. */
  function lookupSwatchRow(map, opi) {
    if (!map || typeof map !== 'object') return null;
    var s = String(opi);
    if (map[s]) return map[s];
    if (map[opi]) return map[opi];
    var keys = Object.keys(map);
    for (var i = 0; i < keys.length; i++) {
      if (norm(keys[i]) === norm(s)) return map[keys[i]];
    }
    return null;
  }

  function lookupSwatchUrl(row, val) {
    if (!row || typeof row !== 'object') return '';
    var n = norm(val);
    if (typeof row[n] === 'string' && row[n]) return row[n];
    var keys = Object.keys(row);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (norm(k) === n && typeof row[k] === 'string') return row[k];
    }
    return '';
  }

function firstVariantImageForOptionValue(variants, opi, valueWant, thumbMap) {
    var want = norm(valueWant);
    for (var i = 0; i < variants.length; i++) {
      var ve = variants[i];
      if (optionValueAt(ve, opi) !== want) continue;
      var url = variantFeaturedSrc(ve);
      if (!url && thumbMap && ve.id != null) {
        url = thumbMap[String(ve.id)] || thumbMap[ve.id] || '';
      }
      if (url) return url;
    }
    return '';
  }

  /**
   * Image for one swatch tile using the full option tuple: current Model/Size (etc.) + this tile's value at opi.
   * So Color thumbnails update when Model or Size changes.
   */
  function variantImageForOptionTuple(variants, selections, opi, valueAtOpi, thumbMap) {
    if (!variants || !selections || selections.length === 0) return '';
    var tuple = selections.slice();
    tuple[opi] = norm(valueAtOpi);
    var v = resolveVariant(variants, tuple);
    if (!v) return '';
    var url = variantFeaturedSrc(v);
    if (!url && thumbMap && v.id != null) {
      url = thumbMap[String(v.id)] || thumbMap[v.id] || '';
    }
    return url || '';
  }

  /**
   * After Model/Size (or any sibling option) changes, refresh visual-option tiles.
   * Prefer per-tuple variant images so Color swatches match the selected Model + Size.
   */
  function updateSwatchImages(root, swatchMap, variants, thumbMap, selections) {
    root.querySelectorAll('.ncvf__btn--swatch[data-ncvf-option-index]').forEach(function (btn) {
      var opi = parseInt(btn.getAttribute('data-ncvf-option-index'), 10);
      if (isNaN(opi)) return;
      var val = norm(btn.getAttribute('data-ncvf-value'));

      var url = variantImageForOptionTuple(variants, selections, opi, val, thumbMap);
      if (!url && swatchMap) {
        var row = lookupSwatchRow(swatchMap, opi);
        url = lookupSwatchUrl(row, val);
      }
      if (!url && variants && variants.length) {
        url = firstVariantImageForOptionValue(variants, opi, val, thumbMap);
      }
      if (!url || typeof url !== 'string') return;

      var frame = btn.querySelector('.ncvf__swatch-frame');
      if (!frame) return;

      var img = frame.querySelector('.ncvf__swatch-img');
      var fb = frame.querySelector('.ncvf__swatch-fallback');

      if (img) {
        img.src = url;
        img.removeAttribute('srcset');
        img.alt = val;
      } else {
        if (fb) fb.remove();
        img = document.createElement('img');
        img.className = 'ncvf__swatch-img';
        img.src = url;
        img.alt = val;
        img.loading = 'lazy';
        img.draggable = false;
        img.width = 140;
        img.height = 140;
        frame.insertBefore(img, frame.firstChild);
      }
    });
  }

  function bindRoot(root) {
    var dataEl = root.querySelector('[data-ncvf-bundle]');
    if (!dataEl) return;

    var bundle = parseJSON(dataEl);
    if (!bundle || !bundle.variants) return;

    var sectionId = bundle.sectionId;
    var variants = bundle.variants;
    var optionOrder = (bundle.optionOrder || []).map(function (row) {
      return row.map(function (x) {
        return norm(x);
      });
    });
    var priceEl = root.querySelector('[data-ncvf-prices]');
    var priceMap = priceEl ? parseJSON(priceEl) : null;
    if (!priceMap || typeof priceMap !== 'object') priceMap = {};
    var titleElScript = root.querySelector('[data-ncvf-product-titles]');
    var titleMap = titleElScript ? parseJSON(titleElScript) : null;
    if (!titleMap || typeof titleMap !== 'object') titleMap = {};
    var swatchEl = root.querySelector('[data-ncvf-swatch-images]');
    var swatchMap = swatchEl ? parseJSON(swatchEl) : null;
    var thumbEl = root.querySelector('[data-ncvf-variant-thumb-urls]');
    var thumbMap = thumbEl ? parseJSON(thumbEl) : null;
    var enableHistory = !!bundle.enableHistory;
    var productUrl = bundle.productUrl || '';
    var showFeaturedMedia = !!bundle.showFeaturedMedia;

    var selections = (bundle.initialSelections || []).map(function (s) {
      return norm(s);
    });

    var sizeOptionIndex =
      bundle.sizeOptionIndex !== undefined && bundle.sizeOptionIndex !== null
        ? bundle.sizeOptionIndex
        : null;

    function applyVisibility() {
      var positions = optionOrder.length;
      for (var p = 0; p < positions; p++) {
        var valid = getValidValues(variants, selections, p);
        var buttons = root.querySelectorAll('.ncvf__btn[data-ncvf-option-index="' + p + '"]');
        for (var i = 0; i < buttons.length; i++) {
          var btn = buttons[i];
          var val = norm(btn.getAttribute('data-ncvf-value'));
          var allowed = valid.indexOf(val) !== -1;
          var isSel = norm(selections[p]) === norm(val);

          if (!allowed) {
            btn.classList.add('ncvf__btn--hidden');
            btn.classList.remove(
              'ncvf__btn--oos',
              'ncvf__btn--available',
              'ncvf__btn--unavailable'
            );
            btn.removeAttribute('aria-disabled');
            continue;
          }

          var matches = findMatchingVariants(variants, selections, p, val);
          var anyAvail = false;
          for (var m = 0; m < matches.length; m++) {
            if (matches[m].available) {
              anyAvail = true;
              break;
            }
          }
          var soldOut = matches.length > 0 && !anyAvail;
          var hideSoldOut = soldOut && !isSel;

          btn.classList.toggle('ncvf__btn--hidden', hideSoldOut);
          if (hideSoldOut) {
            btn.classList.remove(
              'ncvf__btn--oos',
              'ncvf__btn--available',
              'ncvf__btn--unavailable'
            );
            btn.removeAttribute('aria-disabled');
            continue;
          }

          btn.classList.toggle('ncvf__btn--oos', soldOut);
          btn.classList.toggle('ncvf__btn--unavailable', soldOut);
          btn.classList.toggle('ncvf__btn--available', !soldOut);
          if (soldOut) {
            btn.setAttribute('aria-disabled', 'true');
          } else {
            btn.removeAttribute('aria-disabled');
          }
          btn.disabled = false;
        }

        var legendCurrent = root.querySelector('[data-ncvf-current-label="' + p + '"]');
        if (legendCurrent) legendCurrent.textContent = selections[p] != null ? selections[p] : '';
      }

      for (var si = 0; si < positions; si++) {
        var groupBtns = root.querySelectorAll('.ncvf__btn[data-ncvf-option-index="' + si + '"]');
        for (var bi = 0; bi < groupBtns.length; bi++) {
          var b = groupBtns[bi];
          var sel = norm(b.getAttribute('data-ncvf-value')) === norm(selections[si]);
          b.classList.toggle('ncvf__btn--selected', sel);
          b.setAttribute('aria-pressed', sel ? 'true' : 'false');
        }
      }

      if (sizeOptionIndex !== null) {
        var szFs = root.querySelector(
          '.ncvf__fieldset[data-ncvf-option-row="' + sizeOptionIndex + '"]'
        );
        if (szFs) {
          var szValid = getValidValues(variants, selections, sizeOptionIndex);
          var hideSz = shouldHideSizeOnlyZero(szValid);
          szFs.hidden = hideSz;
          szFs.setAttribute('aria-hidden', hideSz ? 'true' : 'false');
        }
      }

      updateSwatchImages(root, swatchMap, variants, thumbMap, selections);
    }

    function updateProductTitle(sectionId, variant, titles) {
      var el = document.getElementById('customProductTitle-' + sectionId);
      if (!el || !variant || !titles || typeof titles !== 'object') return;
      var t = titles[String(variant.id)];
      if (t == null || t === '') t = titles[variant.id];
      if (t != null && String(t) !== '') el.textContent = String(t);
    }

    function commit(variant) {
      updateGhostPickerScript(root, variant);
      updateVariantInputs(sectionId, variant ? variant.id : '');
      replaceHistory(productUrl, variant ? variant.id : null, enableHistory);
      updatePriceEl(sectionId, variant, priceMap);
      updateProductTitle(sectionId, variant, titleMap);
      updateSkuAvailability(sectionId, variant);
      updatePickup(root, variant);
      updateAtc(sectionId, variant);
      updatePricePerItem(sectionId, variant);
      if (!showFeaturedMedia && variant) updateGallery(root, sectionId, variant);
      emitVariantChange(sectionId, variant);
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.ncvf__btn[data-ncvf-value]');
      if (!btn || !root.contains(btn)) return;
      if (btn.classList.contains('ncvf__btn--hidden')) return;
      if (btn.classList.contains('ncvf__btn--unavailable')) return;

      var p = parseInt(btn.getAttribute('data-ncvf-option-index'), 10);
      var val = norm(btn.getAttribute('data-ncvf-value'));

      selections[p] = val;
      selections = normalizeSelections(variants, selections, p, optionOrder);
      applyVisibility();

      var variant = resolveVariant(variants, selections);
      commit(variant);
    });

    applyVisibility();
    commit(resolveVariant(variants, selections));
  }

  function init() {
    document.querySelectorAll('[data-ncvf-root]').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
